import { useEffect, useState } from 'react';
import useEftposAccount from '../../../Hooks/UseEftposAccount';
import LoadingPanel from '../../../Abstracts/Components/LoadingPanel';
import useEftposPosLists from '../../../Hooks/UseEftposPosLists';
import useQuery from '../../../Hooks/UseQuery';
import useUserApi, { ErrorHandler } from '../../../Services/UserApi';
import EditMenuForm, { EditableEftposPosList } from './EditMenuForm';
import { useHistory } from 'react-router-dom';
import { BackButton } from '../BreadCrumbs';

export default function CreateMenu() {
	const { eftposAccount } = useEftposAccount();
	const eftposPosLists = useEftposPosLists();
	const [newMenu, setNewMenu] = useState<EditableEftposPosList>();

	const query = useQuery();
	const context = query.get('context');
	const bookingId = query.get('bookingId');

	let backLocation = '/menus';
	switch (context) {
		case 'dashboard':
			backLocation = '/';
			break;
		case 'bookings':
			backLocation = `/bookings`;
			break;
		case 'menus':
			backLocation = `/menus`;
			break;
	}

	useEffect(() => {
		if (!eftposAccount || !eftposPosLists) {
			return;
		}
		setNewMenu({
			EftposPosListId: 0,
			EftposPosListEftposAccountId: eftposAccount.EftposAccountId,
			EftposPosListName: eftposPosLists.length === 0 ? 'Main menu' : '',
			items: [
				{
					EftposPosListItemId: 0,
					EftposPosListItemName: '',
					EftposPosListItemPrice: '0.00',
					EftposPosListItemGst: 1,
				},
				{
					EftposPosListItemId: 0,
					EftposPosListItemName: '',
					EftposPosListItemPrice: '0.00',
					EftposPosListItemGst: 1,
				},
				{
					EftposPosListItemId: 0,
					EftposPosListItemName: '',
					EftposPosListItemPrice: '0.00',
					EftposPosListItemGst: 1,
				},
				{
					EftposPosListItemId: 0,
					EftposPosListItemName: '',
					EftposPosListItemPrice: '0.00',
					EftposPosListItemGst: 1,
				},
			],
		});
	}, [eftposAccount, eftposPosLists]);

	const userApi = useUserApi();
	const history = useHistory();

	const saveMenu = (menu: EditableEftposPosList) => {
		return userApi({
			route: 'eftpos/api',
			data: {
				action: 'createEftposPosList',
				eftposPosList: menu,
				bookingId,
			},
			errorMessage: 'Error saving menu',
		})
			.then(() => history.push(backLocation))
			.catch((e: unknown) => ErrorHandler.toast(e));
	};

	if (!eftposAccount || !eftposPosLists || !newMenu) {
		return <LoadingPanel />;
	}

	const isFirstMenu = eftposPosLists.length === 0;

	return (
		<>
			<BackButton text="Back" to={backLocation} />
			<EditMenuForm
				menu={newMenu}
				setMenu={setNewMenu}
				onSave={saveMenu}
				isFirstMenu={isFirstMenu}
				saveButtonText="Create menu"
			/>
		</>
	);
}
